<template>
  <div class="container">
    <div class="row">
      <div class="col-12 head-atom">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">
            <div class="back-header">
              <span @click="$router.go(-1)">
                <i class="vik vik-left"></i>back
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="content atom">
          <div class="row item-container">
            <div class="col-lg-12">
              <div class="atom-content">
                <div class="info">
                  <div class="info-list">
                    <!--
                    Пока вырубим. от лукавого.
                    <div class="info-item">
                      <h5>Category:</h5>
                      <el-select v-model="info.category" v-if="editMode">
                        <el-option value="web">Web</el-option>
                        <el-option value="other">Other</el-option>
                      </el-select>

                      <div class="info-item-desc">
                        {{ computedCategory }}
                      </div>
                    </div>
                     -->
                    <div class="info-item">
                      <h5>Author:</h5>
                      <div class="info-item-desc">
                        <!-- <a href="#" class="author-name"></a>-->
                        {{ computedAuthor }}
                      </div>
                    </div>

                    <div class="info-item" v-if="computedUpdated">
                      <h5>Last update:</h5>
                      <div class="info-item-desc">
                        <span>{{ computedUpdated }}</span>
                      </div>
                    </div>

                    <div class="info-item">
                      <h5>Tags:</h5>
                      <div class="info-item-desc">
                        <div class="tags">
                          <el-tag :key="index" v-for="(tag, index) in info.tags" :closable="editMode"
                            :disable-transitions="false" @close="handleCloseTag(tag)">
                            {{ tag }}
                          </el-tag>
                          <div v-if="editMode">
                            <el-input class="input-new-tag" v-if="inputTagVisible" v-model="inputTagValue"
                              ref="saveTagInput" size="mini" @keyup.enter.native="handleInputTagConfirm"
                              @blur="handleInputTagConfirm">
                            </el-input>
                            <el-button v-else class="btn-sm btn-primary" @click="showTagInput"><i
                                class="vik vik-plus-small"></i> new
                              tag</el-button>
                          </div>

                          <!--
                          <span
                            :key="index"
                            v-for="(tag, index) in info.tags"
                            >{{ tag }}</span
                          >
                          -->
                        </div>
                      </div>
                    </div>
                    <div class="info-item" v-if="computedLocalRevision > 0">
                      <h5>Local revision:</h5>
                      <div class="info-item-desc">
                        <span v-if="editMode">
                          <el-input-number :min="1" :max="1000" :step="1" v-model="newRev"
                            controls-position="right"></el-input-number></span>
                        <span v-else>
                          {{ computedLocalRevision }}
                        </span>
                      </div>
                    </div>
                    <div class="info-item" v-if="computedremoteRevisionsion > 0">
                      <h5>Market revision:</h5>
                      <div class="info-item-desc">
                        <span>
                          <div v-if="computedremoteRevisionsion">
                            {{ computedremoteRevisionsion }}
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-bind:class="{
                'installed-list': !showInstall,
                'update-list': showUpdate,
                'download-list': showInstall,
              }">
                    <div class="info-item">
                      <div class="info-item-desc">
                        <el-button type="button" class="btn btn-secondary" @click="install" icon="vik vik-download"
                          :loading="installing" v-if="showInstall">
                          Install
                        </el-button>

                        <span v-if="!showInstall && !showUpdate && 'code' in marketData
                ">
                          <i class="vik vik-check" style="margin-right: 5px"></i>
                          Installed
                        </span>

                        <el-button type="button" class="btn btn-secondary" @click="install" icon="vik vik-download"
                          :loading="installing" v-if="showUpdate">
                          Update
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="description" style="width: 100%">
                  <div class="description-cont">
                    <div class="head-description">
                      <!-- 
                      <div class="verified">
                        <i class="vik vik-verified-dc"
                          ><span class="path1"></span
                          ><span class="path2"></span></i
                        >verified atom
                      </div>
                
                      <div
                        class="atom-type"
                        :class="[
                          {
                            web: info.type == 'web',
                            native: info.type == 'native',
                          },
                        ]"
                      >
                        {{ info.type }}
                      </div>
                      -->
                    </div>
                    <!-- if edit mode is enabled -->
                    <div v-if="editMode">
                      <el-form @submit.native.prevent>
                        <el-form-item label="Title">
                          <el-input v-if="editMode" v-model="info.title"></el-input></el-form-item>
                        <el-form-item label="Description">
                          <el-input v-if="editMode" v-model="info.description" type="textarea" :rows="3"
                            placeholder="Description"></el-input>
                        </el-form-item>
                      </el-form>
                    </div>
                    <!-- normal mode -->
                    <div v-else>
                      <h2>{{ info.title }}</h2>
                      <p>{{ computedDescription }}</p>
                    </div>
                  </div>
                </div>
                <div class="changelog">
                  <div class="control-block d-flex align-items-center mb-4">
                    <div class="btn-line-icon">
                      <el-popover placement="bottom" v-model="showRemovePop">
                        <div class="modal-head-icon">
                          <i class="vik vik-info-c"></i>
                        </div>
                        <p>Are you sure to delete script?</p>
                        <div class="btn-line" style="text-align: right; margin: 0">
                          <el-button @click="showRemovePop = false" class="btn btn-primary">No</el-button>
                          <el-button class="btn btn-link" @click="removeScript">Yes</el-button>
                        </div>
                      </el-popover>
                      <el-button v-show="thereIsLocalAtom && iamauthor && !editMode" @click="enableEditMode"
                        type="button" title="Edit atom information" class="btn-sm btn-link">
                        <i class="vik vik-edit"></i>
                      </el-button>

                      <el-button class="btn-sm btn-link" @click="forkAtom" v-if="!editMode">
                        Fork
                      </el-button>
                      <el-button class="btn-sm btn-link" v-if="editMode" @click="editMode = false">
                        <i class="vik vik-x"></i>
                      </el-button>
                      <el-button class="btn-sm btn-link" v-if="editMode" @click="handleSave" :loading="loading"
                        icon="vik vik-save">
                      </el-button>
                    </div>
                    <button v-if="!editMode" type="button" class="btn-sm btn-link" @click="SettingsDrawer = true"
                      title="Variables">
                      <i class="vik vik-settings"></i>Settings
                    </button>
                    <button slot="reference" v-if="showRemove && !editMode" title="Remove" class="btn-sm btn-link"
                      @click="showRemovePop = true">
                      <i class="vik vik-delete"></i>
                    </button>
                  </div>

                  <div class="aux-block">
                    <button class="btn btn-lg btn-primary w-100" title="Not available" v-if="showPublishButton"
                      :disabled="!has_api_key" type="button" @click="showPublishDialog">
                      <i class="vik vik-share"></i>{{ publishText }}
                    </button>
                  </div>
                </div>

                <!--
                <div class="changelog">

                  <div class="new-version">
                    <h2>New in 1.01 version</h2>
                    <p>
                      even more shitty code;
                      <br />2 times longer query execution; <br />stack overflow
                      immediately after launch;
                    </p>
                  </div>
                  <div class="version-list">
                    <h2>Changelog</h2>
                    <ul class="change-list">
                      <li>
                        <a href="Atom-single-page-update.html">update page</a>
                      </li>
                    </ul>
                  </div>
                </div>
                -->
              </div>

              <div v-if="info.type == 'yaml'">
                <div class="code-listing" v-if="localData != null">
                  <h2 v-if="localData.code">YAML</h2>
                  <CodeExpander v-show="localData.code">
                    <div class="black-editor-cont">
                      <Editor editorId="atom-editor-yaml" ref="atomEditor" :readOnly="readOnlyEditor" :lang="info.type">
                      </Editor>
                    </div>
                  </CodeExpander>
                  <br />
                  <h2 v-if="marketData.code">Market code</h2>
                  <CodeExpander v-show="marketData.code">
                    <div class="black-editor-cont">
                      <Editor :editorId="'atom-editor-market'" ref="atomEditorMarket" :readOnly="true" theme="vikingo"
                        lang="yaml"></Editor>
                    </div>
                  </CodeExpander>
                </div>
              </div>
              <!-- <div v-if="info.type == 'web'">
                <el-form>
                  <h2>Chain</h2>
                  <el-form-item>
                    <div class="atom-tree">
                      <ul>
                        <li
                          class="atom-tree-item"
                          inline
                          :key="index"
                          v-for="(tx, index) in chain.requests"
                        >
                          <div class="num">{{ index + 1 }}.</div>
                          <div class="atom-tree-item-cont">
                            <el-form-item label="Request">
                              <div class="code-listing">
                                <CodeExpander>
                                  <div class="black-editor-cont">
                                    <Editor
                                      :content="tx.request"
                                      :editorId="'editor-req-' + index"
                                      :ref="'editor-req-' + index"
                                      :onUpdateContent="onUpdateRequestBody"
                                      :additionalParams="{ index: index }"
                                      :readOnly="readOnlyEditor"
                                      lang="httpreq"
                                      theme="vikingo"
                                    ></Editor>
                                  </div>
                                </CodeExpander>
                                <button
                                  style="margin-top: 15px"
                                  @click="showModal(index)"
                                  type="button"
                                  class="btn-sm btn-primary"
                                  v-if="editMode"
                                >
                                  <i class="vik vik-plus"></i>Load request
                                </button>
                              </div>
                            </el-form-item>
                            <el-form-item label="Hooks">
                              <div class="black-editor-cont">
                                <Editor
                                  :editorId="'editor-' + index"
                                  :content="tx.hooks"
                                  :height="200"
                                  :onUpdateContent="onUpdateContent"
                                  :additionalParams="{ index: index }"
                                  theme="vikingo"
                                  lang="lua"
                                  :readOnly="readOnlyEditor"
                                ></Editor>
                              </div>
                            </el-form-item>
                            <el-form-item v-if="editMode">
                              <div class="btn-line">
                                <el-button
                                  v-if="chain.requests.length > 1"
                                  @click="removeItemByIndex(index)"
                                  type="button"
                                  class="btn-sm btn-danger"
                                  icon="vik vik-delete"
                                >
                                  Remove
                                </el-button>
                              </div>
                            </el-form-item>
                          </div>
                        </li>
                      </ul>
                      <button
                        v-if="editMode"
                        @click="addItemToChain"
                        type="button"
                        class="btn btn-primary"
                      >
                        <i class="vik vik-plus"></i>Add item to chain
                      </button>
                    </div>
                  </el-form-item>
                </el-form>
              </div> -->
              <div v-if="info.type == 'native' || info.type == 'lua'">
                <div class="code-listing" v-if="localData != null">
                  <h2 v-if="localData.code">Local code</h2>
                  <CodeExpander v-show="localData.code">
                    <div class="black-editor-cont">
                      <Editor :editorId="'atom-editor'" ref="atomEditor" :readOnly="readOnlyEditor" theme="vikingo"
                        lang="lua"></Editor>
                    </div>
                  </CodeExpander>
                  <br />
                  <h2 v-if="marketData.code">Market code</h2>
                  <CodeExpander v-show="marketData.code">
                    <div class="black-editor-cont">
                      <Editor :editorId="'atom-editor-market'" ref="atomEditorMarket" :readOnly="true" theme="vikingo"
                        lang="lua"></Editor>
                    </div>
                  </CodeExpander>
                </div>
              </div>

              <div v-if="info.type == 'native'">
                <div v-if="info.settings.length">
                  <div class="atom-tree">
                    <ul>
                      <li class="atom-tree-item" inline :key="idx" v-for="(item, idx) in info.settings"
                        style="margin-bottom: 25px">
                        <el-form :ref="`paramForm` + idx" :model="item">
                          <div class="num">{{ idx + 1 }}.</div>
                          <div class="atom-tree-item-cont">
                            <el-form-item label="Title">
                              <el-input v-model="item.title" placeholder="For example: fisrt parameter"
                                :disabled="!editMode"></el-input>
                            </el-form-item>
                            <el-form-item prop="name" label="Name" :rules="{
                required: true,
                message: 'Name can not be empty',
                trigger: 'blur',
              }">
                              <el-input v-model="item.name" placeholder="For example: set_one"
                                :disabled="!editMode"></el-input>
                            </el-form-item>
                            <div class="item-cont-group">
                              <h4 class="tree-title-group">View</h4>
                              <div class="variables-group">
                                <el-form-item class="choose-var" prop="view">
                                  <el-select v-model="item.view" :disabled="!editMode">
                                    <el-option value="multiselect">Multiselect</el-option>
                                    <el-option value="string">String</el-option>
                                    <el-option value="checkbox">Checkbox</el-option>
                                  </el-select>
                                </el-form-item>

                                <div class="control-var-item">
                                  <el-form-item prop="value">
                                    <el-checkbox v-if="item.view == 'checkbox'" v-model="item.modelBool"
                                      :disabled="!editMode">checked</el-checkbox>
                                    <el-select v-if="item.view == 'multiselect'" v-model="item.modelMultiselect"
                                      allow-create filterable multiple default-first-option :disabled="!editMode">
                                      <el-option v-for="val in item.value" :value="val" :key="val" :label="val">{{ val
                                        }}</el-option>
                                    </el-select>
                                    <el-input v-if="item.view == 'string'" v-model="item.modelString"
                                      placeholder="Default value" :disabled="!editMode"></el-input>
                                  </el-form-item>
                                </div>
                              </div>
                            </div>
                            <el-form-item>
                              <button type="button" @click="handleRemove(idx)"
                                class="btn-sm btn-outline btn-outline-danger" v-if="editMode">
                                <i class="vik vik-delete"></i>Delete
                              </button>
                            </el-form-item>
                          </div>
                        </el-form>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="form-group" v-if="editMode">
                  <div class="btn-line">
                    <button @click="addSetting" type="button" class="btn btn-primary">
                      <i class="vik vik-plus"></i>Add setting
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <el-drawer
        title="Settings"
        size="25%"
        direction="rtl"
        :append-to-body="true"
        :visible.sync="SettingsDrawer"
      >
       
        <el-form @submit.native.prevent v-if="info.type == 'web'">
          <el-form-item>
            <div
              v-bind:key="idx"
              v-for="(v, idx) in chain.settings"
              class="mrg"
            >
              <div class="block33" style="margin-bottom: 5px">
                <el-checkbox
                  :disabled="!editMode"
                  v-if="v.view == 'checkbox'"
                  v-model="chain.settings[idx].value"
                  >{{ v.title }}</el-checkbox
                >
                <div v-if="v.view == 'multiselect'">
                  <label class="setting-title" style="margin-right: 10px">{{
                    v.title
                  }}</label>
                  <el-select
                    :disabled="!editMode"
                    v-model="chain.settings[idx].value"
                    filterable
                    multiple
                    allow-create
                    default-first-option
                    :placeholder="chain.settings[idx].title"
                    style="margin-bottom: 15px"
                  >
                    <el-option
                      v-for="item in v.value"
                      :value="item"
                      :key="item"
                      >{{ item }}</el-option
                    >
                  </el-select>
                </div>
                <div v-if="v.view == 'string'">
                  <h4 class="setting-title">{{ v.title }}</h4>
                  <el-input
                    :disabled="!editMode"
                    v-model="chain.settings[idx].value"
                  ></el-input>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>

        
      </el-drawer> -->

      <el-dialog :title="publishText" :visible.sync="showPublish">
        <el-form ref="marketForm" :model="marketForm" :rules="marketFormValidate">
          <el-form-item label="Title" prop="title">
            <el-input v-model="marketForm.title" placeholder="Enter something..." disabled />
          </el-form-item>
          <el-form-item label="Description" prop="description">
            <el-input v-model="marketForm.description" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="Enter something about this atom. What does it do?" disabled />
          </el-form-item>
          <el-form-item label="Visibility" prop="visibility">
            <el-radio-group v-model="marketForm.visibility" size="mini">
              <el-radio-button label="private">Private</el-radio-button>
              <el-radio-button label="public">Public</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="Tags" prop="tags">
            <el-tag :key="index" v-for="(tag, index) in info.tags">
              {{ tag }}
            </el-tag>
          </el-form-item>
        </el-form>

        <div slot="footer">
          <el-button @click="showPublish = false" type="button" class="btn btn-cancel">Cancel</el-button>
          <el-button type="button" class="btn btn-success" @click="handlePublish">Submit</el-button>
        </div>
      </el-dialog>
    </div>
    <!--
    <div class="row item-container atom-grid">
      <h2 class="content-title col-12" style="margin-bottom: 30px">
        Same atoms in Marketplace
      </h2>

      <div class="col-lg-3">
        <article class="mini-card small">
          <div class="mini-card-type web">
            <span>web</span>
          </div>
          <div class="mini-article-card-header">
            <div class="tags">
              <span>must have</span>
              <span>system</span>
            </div>
            <div class="btn-group ml-auto">
              <button class="btn btn-sm btn-icon">
                <i class="vik vik-download-dc">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </button>
            </div>
          </div>

          <div class="mini-article-card-title">
            <h3>
              E-Commerce System 1.0 - Unauthenticated Remote Code Execution
              (CVE-2014-2048)
            </h3>
            <p>
              A quality visualization tool to identify and prioritize technical
              debt and evaluate your organizational efficiency
            </p>
          </div>
        </article>
      </div>

      <div class="col-lg-3">
        <article class="mini-card small">
          <div class="mini-card-type native">
            <span>native</span>
          </div>
          <div class="mini-article-card-header">
            <div class="tags">
              <span>must have</span>
              <span>injection</span>
            </div>
            <div class="btn-group ml-auto">
              <button class="btn btn-sm btn-icon">
                <i class="vik vik-download-dc">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </button>
            </div>
          </div>
          <div class="mini-article-card-title">
            <h3>Space injection — S3XY</h3>
            <p>
              A quality visualization tool to identify and prioritize technical
              debt and evaluate your organizational efficiency
            </p>
          </div>
        </article>
      </div>

      <div class="col-lg-3">
        <article class="mini-card small">
          <div class="mini-card-type native">
            <span>native</span>
          </div>



      <div class="col-lg-3">
        <article class="mini-card small">
          <div class="mini-card-type native">
            <span>native</span>
          </div>
          <div class="mini-article-card-header">
            <div class="tags">
              <span>must have</span>
              <span>tg</span>
              <span>CVE</span>
            </div>
            <div class="btn-group ml-auto">
              <button class="btn btn-sm btn-icon">
                <div class="badge badge-update">
                  <span>new update</span>
                </div>
                <i class="vik vik-update-dc">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </button>
            </div>
          </div>

          <div class="mini-article-card-title">
            <h3>CVE-1488 telegram</h3>
            <p>
              A quality visualization tool to identify and prioritize technical
              debt and evaluate your organizational efficiency
            </p>
          </div>
        </article>
      </div>

      <div class="col-lg-3">
        <article class="mini-card small">
          <div class="mini-card-type native">
            <span>native</span>
          </div>
          <div class="mini-article-card-header">
            <div class="tags">
              <span>must have</span>
              <span>dos</span>
            </div>
            <div class="btn-group ml-auto">
              <button class="btn btn-sm btn-icon">
                <i class="vik vik-download-dc">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </button>
            </div>
          </div>
          <div class="mini-article-card-title">
            <h3>DoS — twitter</h3>
            <p>
              A quality visualization tool to identify and prioritize technical
              debt and evaluate your organizational efficiency
            </p>
          </div>
        </article>
      </div>
    </div>
    -->
  </div>
  <!--
  <div class="container">
    <div class="row">
      <div class="col-12 head-atom">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">
            <div class="back-header">
              <a href>
                <i>
                  <svg
                    width="7"
                    height="12"
                    viewBox="0 0 7 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.245129 6.57614C-0.0817098 6.25794 -0.0817098 5.74205 0.245129 5.42386L5.57128 0.238643C5.89812 -0.0795478 6.42803 -0.0795478 6.75487 0.238643C7.08171 0.556834 7.08171 1.07272 6.75487 1.39091L2.02051 6L6.75487 10.6091C7.08171 10.9273 7.08171 11.4432 6.75487 11.7614C6.42803 12.0795 5.89812 12.0795 5.57128 11.7614L0.245129 6.57614Z"
                      fill="#2D3139"
                    />
                  </svg>
                </i>
                back to Marketplace
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="content">
          <div class="row item-container">
            <div class="col-lg-12">
              <div class="atom-content">
                <div class="info">
                  <div class="info-item">
                    <h5>Category:</h5>
                    <div class="info-item-desc">
                      <a href="#" class="cat-name">Name cat</a>
                    </div>
                  </div>
                  <div class="info-item">
                    <h5>Autor:</h5>
                    <div class="info-item-desc">
                      <a href="#" class="author-name">bill_cool_gates</a>
                    </div>
                  </div>

                  <div class="info-item">
                    <h5>Last update:</h5>
                    <div class="info-item-desc">
                      <span>28.12.2019</span>
                    </div>
                  </div>
                  <div class="info-item">
                    <h5>Tags:</h5>
                    <div class="info-item-desc">
                      <div class="tags">
                        <span>must have</span>
                        <span>tg</span>
                        <span>CVE</span>
                      </div>
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="update">
                      <h5>
                        New update
                        <span>(1.01 version)</span>
                      </h5>
                      <span>31.05.2020</span>
                    </div>
                    <div class="info-item-desc">
                      <button type="button" class="btn btn-primary">
                        <i class="vik vik-update"></i>Update
                      </button>
                    </div>
                  </div>
                </div>
                <div class="description">
                  <span class="verified">verified atom</span>
                  <div class="btn-line" style="display: inline-block; margin-left: 30px;">
                    <button type="button" class="btn-outline btn-sm btn-outline-secondary">
                      <i class="vik vik-add-group"></i>Clone
                    </button>
                  </div>


                </div>
                <div class="changelog">
                  <div class="new-version">
                    <h2>New in 1.01 version</h2>
                    <p>
                      even more shitty code;
                      <br />2 times longer query execution;
                      <br />stack overflow immediately after launch;
                    </p>
                  </div>
                  <div class="version-list">
                    <h2>Changelog</h2>
                    <ul class="change-list">
                      <li>
                        <a href="#">0.90</a>
                      </li>
                      <li>
                        <a href="#">0.97</a>
                      </li>
                      <li>
                        <a href="#">0.99</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="code-listing">
                <div style="background: #1D1F21; border-radius: 8px 8px 0 0; padding: 20px 10px;">
                  <Editor :editorId="'atom-editor'" ref="atomEditor" :readOnly="true"></Editor>
                </div>
                <div class="code-block-control">
                  <button class="btn btn-all-width" style="height: 100%;">
                    <i class="vik vik-down"></i>Expand
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row item-container atom-grid">
      <h2 class="content-title col-12" style="margin-bottom: 30px;">Same atoms in Marketplace</h2>

      <div class="col-lg-3">
        <article class="mini-card small">
          <div class="mini-card-type web">
            <span>web</span>
          </div>
          <div class="mini-article-card-header">
            <div class="tags">
              <span>must have</span>
              <span>system</span>
            </div>
            <div class="btn-group ml-auto">
              <button class="btn btn-sm btn-icon">
                <i class="vik vik-download-dc">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </button>
            </div>
          </div>

          <div class="mini-article-card-title">
            <h3>E-Commerce System 1.0 - Unauthenticated Remote Code Execution (CVE-2014-2048)</h3>
            <p>A quality visualization tool to identify and prioritize technical debt and evaluate your organizational efficiency</p>
          </div>
        </article>
      </div>

      <div class="col-lg-3">
        <article class="mini-card small">
          <div class="mini-card-type native">
            <span>native</span>
          </div>
          <div class="mini-article-card-header">
            <div class="tags">
              <span>must have</span>
            </div>
            <div class="btn-group ml-auto">
              <button class="btn btn-sm btn-icon">
                <i class="vik vik-download-dc">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </button>
            </div>
          </div>
          <div class="mini-article-card-title">
            <h3>Space injection — S3XY</h3>
            <p>A quality visualization tool to identify and prioritize technical debt and evaluate your organizational efficiency</p>
          </div>
        </article>
      </div>

      <div class="col-lg-3">
        <article class="mini-card small">
          <div class="mini-card-type native">
            <span>native</span>
          </div>
          <div class="mini-article-card-header">
            <div class="tags">
              <span>must have</span>
              <span>verification</span>
              <span>request</span>
            </div>
            <div class="btn-group ml-auto">
              <button class="btn btn-sm btn-icon">
                <div class="badge badge-update">
                  <span>new update</span>
                </div>
                <i class="vik vik-update-dc">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </button>
            </div>
          </div>

          <div class="mini-article-card-title">
            <h3>Chip verification in request body 0x060606</h3>
            <p>A quality visualization tool to identify and prioritize technical debt and evaluate your organizational efficiency</p>
          </div>
        </article>
      </div>

      <div class="col-lg-3">
        <article class="mini-card small">
          <div class="mini-card-type native">
            <span>native</span>
          </div>
          <div class="mini-article-card-header">
            <div class="tags">
              <span>must have</span>
              <span>tg</span>
              <span>CVE</span>
            </div>
            <div class="btn-group ml-auto">
              <button class="btn btn-sm btn-icon">
                <div class="badge badge-update">
                  <span>new update</span>
                </div>
                <i class="vik vik-update-dc">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </button>
            </div>
          </div>

          <div class="mini-article-card-title">
            <h3>CVE-1488 telegram</h3>
            <p>A quality visualization tool to identify and prioritize technical debt and evaluate your organizational efficiency</p>
          </div>
        </article>
      </div>

      <div class="col-lg-3">
        <article class="mini-card small">
          <div class="mini-card-type native">
            <span>native</span>
          </div>
          <div class="mini-article-card-header">
            <div class="tags">
              <span>must have</span>
              <span>dos</span>
            </div>
            <div class="btn-group ml-auto">
              <button class="btn btn-sm btn-icon">
                <i class="vik vik-download-dc">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </button>
            </div>
          </div>
          <div class="mini-article-card-title">
            <h3>DoS — twitter</h3>
            <p>A quality visualization tool to identify and prioritize technical debt and evaluate your organizational efficiency</p>
          </div>
        </article>
      </div>
    </div>
  </div>
  -->
</template>

<script>
import Editor from "@/components/internal/Editor.vue";
import CodeExpander from "@/components/internal/CodeExpander.vue";
import * as utils from "@/utils.js";
import moment from "moment";
import NAB from "@/components/internal/NativeAtomBuilder.vue";
import { removeScript, newScript } from "@/api.js";

export default {
  mixins: [NAB],
  data() {
    return {
      loading: false,
      installing: false,
      info: {
        type: "native",
        title: "",
        description: "",
        visibility: "public",
        settings: [],
        category: "",
        author: "",
        tags: [],
        updated: "",
        version: 0,
        localRevision: 0,
        remoteRevision: 0,
        verified: false,
      },
      inputTagVisible: false,
      inputTagValue: "",
      chain: {},
      has_api_key: false,
      there_is_new_version: false,
      showPublish: false,
      showPublishButton: false,
      showRemove: false,
      showInstalled: false,
      showInstall: false,
      showUpdate: false,
      showLocalCode: false,
      showMarketCode: false,
      editMode: false,
      SettingsDrawer: false,
      publishText: "",
      newRev: 1,

      localData: {},
      marketData: {},
      thereIsMarketAtom: false,
      thereIsLocalAtom: false,

      publish_title: "Publish to marketplace",
      marketForm: {
        title: "",
        description: "",
        visibility: "public",
        tags: [],
        category: "",
      },
      showRemovePop: false,
      singleItem: {
        request: "",
        hooks: `local db = require"db"\n\nfunction on_response(response,raw_request,info)\n\tprint(raw_request,response.body)\n\treturn false\nend`,
        // actions: [],
      },
      marketFormValidate: {
        title: [
          {
            required: true,
            message: "The field cannot be empty",
            trigger: "blur",
          },
        ],
        visibility: [
          {
            required: true,
            message: "Select one",
            trigger: "change",
          },
        ],
        description: [
          {
            required: true,
            message: "The field cannot be empty",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: { Editor, CodeExpander },
  async mounted() {
    let that = this;
    this.loadData();
    this.has_api_key = await utils.getAPIKey();
    // console.log("has_api_key =", await utils.getAPIKey(), this.has_api_key);
  },

  watch: {
    $route(to, from) {
      this.loadData();
    },
  },
  methods: {
    async loadData() {
      this.loading = true;
      this.publishText = "Publish atom";
      let l, r;
      try {
        console.log("load local atom info");
        l = await utils.loadLocalAtomInfo(this.$route.params.id);
      } catch (e) { }
      try {
        console.log("load market atom info");
        r = await utils.marketplaceAtomInfo(this.$route.params.id);
      } catch (e) { }
      this.loading = false;
      if (l && !l.error) {
        this.thereIsLocalAtom = true;
        this.localData = l;
      }
      if (r && r.data) {
        console.log("==============", r, r.data);
        this.thereIsMarketAtom = true;
        this.marketData = r.data;
      }

      if (this.thereIsLocalAtom) {
        console.log("thereIsLocalAtom", this.localData);
        this.info.type = this.localData.type;
        this.info.title = this.localData.title;
        this.info.description = this.localData.description;
        this.info.author = this.localData.author ? this.localData.author : "me";
        this.info.localRevision = parseFloat(this.localData.revision);
        if (this.localData.tags) {
          try {
            this.info.tags = JSON.parse(this.localData.tags);
          } catch (e) { }
        }
        if (this.localData.type == "web") {
          // parse code as web atom
          this.chain = JSON.parse(this.localData.code);
        } else {
          if (this.localData.settings)
            this.info.settings = this.localData.settings; // JSON.parse(this.localData.settings);
          if (this.localData.code)
            this.$refs.atomEditor.setValue(this.localData.code);
        }
        this.showRemove = true;
        if (this.iamauthor) {
          this.showPublishButton = true;
        }
      }

      if (this.thereIsMarketAtom) {
        console.log("thereIsMarketAtom");
        if (l && !l.error) {
          // atom already installed
          this.showInstalled = true;
          if (this.iamauthor) {
            // check changes
            this.publishText = "Publish changes";
          }
          if (this.info.remoteRevision > parseFloat(this.info.localRevision)) {
            this.showUpdate = true;
          }
        } else {
          // only remote
          this.showInstall = true;
          this.showPublish = false;
        }
        console.log("atom type", r.data.type);
        this.info.type = this.marketData.type;
        this.info.title = this.marketData.title;
        this.info.description = this.marketData.description;
        this.info.category = this.marketData.category;
        this.info.author = this.marketData.author;

        if (this.marketData.mine == "1") {
          this.info.author = "me";
        }

        this.info.tags = r.data.tags;
        this.info.remoteRevision = parseFloat(this.marketData.revision);
        this.$refs.atomEditorMarket.setValue(this.marketData.code);
        this.info.updated = this.marketData.updated;
      }
    },
    enableEditMode() {
      this.newRev = this.info.localRevision + 0;
      this.editMode = true;
    },
    async sendToMarketplace() {
      let publishParams = {
        title: this.marketForm.title,
        description: this.marketForm.description,
        type: this.marketForm.type,
        code: this.marketForm.code,
        id: this.$route.params.id,
        visibility: this.marketForm.visibility,
        tags: this.marketForm.tags,
        category: this.marketForm.category,
      };
      let res = await utils.publishAtomToMarketplace(publishParams);
      if (res.error) {
        this.$notify({
          title: "Error",
          message: res.error,
          type: "error",
        });
      } else {
        this.$notify({
          title: "Success",
          message: "Publish completed",
          type: "success",
        });
        this.showPublish = false;
      }
    },
    handleCloseTag(tag) {
      this.info.tags.splice(this.info.tags.indexOf(tag), 1);
    },
    showTagInput() {
      this.inputTagVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    showPublishDialog() {
      this.marketForm.title = this.info.title;
      // visibility is public by default
      this.marketForm.description = this.info.description;
      this.marketForm.tags = this.info.tags;
      this.marketForm.type = this.info.type;
      this.marketForm.category = this.info.category;

      if (this.info.type == "web") {
        this.marketForm.code = JSON.stringify(this.chain, null, 2);
      } else {
        this.marketForm.code = this.$refs.atomEditor.getValue();
      }
      this.showPublish = true;
    },

    handleInputTagConfirm() {
      let inputValue = this.inputTagValue;
      if (inputValue) {
        this.info.tags.push(inputValue);
      }
      this.inputTagVisible = false;
      this.inputTagValue = "";
    },
    handleSave() {
      let that = this;
      // check new version
      let newRevision = this.newRev;
      if (newRevision <= this.info.localRevision /* && code changed*/) {
        //that.$notify.error({
        //  title: "Error",
        //  message: "New version should be higher than " + this.info.localRevision,
        //});
        // return;
      }

      this.loading = true;

      let code = "";
      if (this.info.type == "web") {
        code = JSON.stringify(this.chain, null, 2);
      } else {
        code = this.$refs.atomEditor.getValue();
      }

      let o = {
        id: this.$route.params.id,
        type: this.info.type,
        title: this.info.title,
        description: this.info.description,
        code: code,
        settings: this.info.settings,
        tags: this.info.tags,
        revision: newRevision,
      };

      newScript(o).then((res) => {
        that.loading = false;
        if (res.error == null) {
          that.info.localRevision = newRevision;
          that.editMode = false;
          that.$notify({
            type: "success",
            title: "Success",
            message: "Script updated",
          });
          // bus.$emit("refresh-atoms");
        } else {
          that.$notify({
            type: "error",
            title: "Error",
            message: res.error,
          });
        }
      });
      return;
      utils.sendPost("/api/atoms/save/", o).then((resp) => {
        that.loading = false;
        if (resp.error == null) {
          that.info.localRevision = newRevision;
          that.editMode = false;
          that.$notify({
            type: "success",
            title: "Success",
            message: "Script updated",
          });
          // bus.$emit("refresh-atoms");
        } else {
          that.$notify({
            type: "error",
            title: "Error",
            message: resp.error,
          });
        }
      });
    },
    handlePublish() {
      this.loading = true;
      this.$refs["marketForm"].validate((valid) => {
        if (valid) {
          this.sendToMarketplace();
        } else {
          this.$Message.error("Fill the fields");
        }
      });
      this.loading = false;
    },

    closeModal() {
      this.$Modal.remove();
    },
    async forkAtom() {
      let that = this;
      this.installing = true;
      this.showInstalled = true;
      await utils.cloneAtom(this.$route.params.id);

      setTimeout(() => {
        that.installing = false;
        that.showInstalled = false;
        that.showInstall = false;
        that.$notify.success({
          title: "Success",
          message: "Atom forked",
        });
        that.loadData();
      }, 1500);
    },
    async install() {
      let that = this;
      this.installing = true;
      this.showInstalled = true;
      await utils.installAtom(this.$route.params.id);

      setTimeout(() => {
        that.installing = false;
        that.showInstalled = false;
        that.showInstall = false;
        that.$notify.success({
          title: "Success",
          message: "Atom installed",
        });
        that.loadData();
      }, 1500);
    },
    removeScript() {
      removeScript(this.$route.params.id).then((data) => {
        this.$notify.success({
          title: "Success",
          message: "Script removed",
        });
        this.showRemove = false;
        this.$router.push({
          name: "AtomsLocal",
        });
      });
    },
    addItemToChain() {
      this.chain.requests.push(Object.assign({}, this.singleItem));
    },
    removeItemByIndex(index) {
      if (index > -1) {
        this.chain.requests.splice(index, 1);
      }
    },
    onUpdateRequestBody(body, params) {
      this.chain.requests[params.index].request = body;
    },
    onUpdateContent(code, params) {
      this.chain.requests[params.index].hooks = code;
    },
  },
  computed: {
    computedDescription() {
      return this.info.description ? this.info.description : "-";
    },
    computedCategory() {
      return utils.capitalize(this.info.category);
    },
    computedAuthor() {
      if (this.info.author) {
        let parts = this.info.author.split(":");
        if (parts.length > 1) {
          return parts[0].substring(0, 15);
        } else {
          return this.info.author;
        }
        return "-";
      }
    },
    computedUpdated() {
      if (this.info.updated) {
        let d = new Date(Date.parse(this.info.updated));
        return moment(d).format("YYYY-MM-DD HH:mm:ss");
      }
      return "";
    },
    computedLocalRevision() {
      return this.info.localRevision; //.toFixed(1);
    },
    computedremoteRevisionsion() {
      return this.info.remoteRevision; //.toFixed(1);
    },
    iamauthor() {
      return "me" === this.info.author;
    },
    showSave() {
      return false;
    },
    readOnlyEditor() {
      if (this.iamauthor && this.editMode) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style>
.el-tag+.el-tag {
  margin-left: 10px;
}

.input-new-tag {
  width: 100px;
  margin-left: 10px;
  vertical-align: bottom;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/SingleAtom.vue